module.exports = __webpack_public_path__ + "static/media/raycast_example.c9fd86df.png";